import { createFileRoute, redirect } from "@tanstack/react-router";
import SignIn from "../pages/SignIn";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/sign-in")({
  head: () => pageHead("page.signIn"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    if (context.auth?.user) {
      throw redirect({ to: "/" });
    }
  },
  component: SignInPage,
});

function SignInPage() {
  return <SignIn />;
}
